/**
 * Teksty kalendarza z tajnego adresu iCal (Ustawienia → Integracje, karta „Kalendarz (link iCal)”; spotkania
 * z kalendarza). Nazwy w Kalendarzu Google po polsku jak w interfejsie Google (7.10.2026; po angielsku „Secret address
 * in iCal format”).
 */

/** Nazwa karty kalendarza z linku iCal (rodzaj `google_calendar`, dostawca `ics` albo jeszcze niepodłączony). */
export const ICS_CALENDAR_TITLE = 'Kalendarz (link iCal)';
/** Nazwa karty kalendarza połączonego kontem Google (OAuth, alternatywa). */
export const GOOGLE_CALENDAR_TITLE = 'Kalendarz Google';

export const ICS_FORM_TEXTS = {
  intro:
    'Spotkania z Twojego kalendarza pojawią się w Spotkaniach, w Dziś („Najbliższe spotkanie”) i w profilu klienta. Tylko odczyt — nic nie zmieniamy w kalendarzu.',
  urlLabel: 'Tajny adres w formacie iCal',
  urlHint:
    'Zapisujemy go zaszyfrowany i nigdy nie pokazujemy. Kto zna ten adres, widzi Twój kalendarz — nie wysyłaj go nikomu.',
  urlKeep: 'Zostaw puste, aby zachować zapisany adres. Zapisujemy go zaszyfrowany i nigdy nie pokazujemy.',
  howToTitle: 'Skąd wziąć adres',
  howTo: [
    'Otwórz Kalendarz Google w przeglądarce na komputerze.',
    'Kliknij ⚙ → Ustawienia, a po lewej wybierz swój kalendarz.',
    'W sekcji „Integracja kalendarza” skopiuj „Tajny adres w formacie iCal”.',
  ],
  howToNote:
    'Jeśli adres wycieknie, kliknij w Google „Zresetuj” przy tym adresie i wklej tu nowy. Inne kalendarze (Apple, Outlook) też mają adres iCal — wklej go tak samo.',
  privacy:
    'Spotkania z kalendarza widzisz tylko Ty. Wybrane spotkanie możesz udostępnić zespołowi (wtedy widzą je osoby z dostępem do klienta).',
} as const;

export const CALENDAR_MEETING_TEXTS = {
  badge: 'Z kalendarza',
  privateMine: 'Spotkanie z Twojego kalendarza — widzisz je tylko Ty.',
  sharedMine: 'Spotkanie z Twojego kalendarza — udostępnione zespołowi.',
  sharedForeign: (owner: string | null) =>
    `Spotkanie z kalendarza${owner ? `: ${owner}` : ''} — udostępnione zespołowi.`,
  company: 'Spotkanie z kalendarza firmowego.',
  share: 'Udostępnij zespołowi',
  unshare: 'Cofnij udostępnienie',
  sharedToast: 'Udostępniono zespołowi',
  unsharedToast: 'Spotkanie znowu widzisz tylko Ty',
  fieldsHint: 'Tytuł, termin, miejsce i uczestników zmienisz w kalendarzu — tu przypiszesz klienta, projekt i notatki.',
  syncNow: 'Synchronizuj teraz',
  syncQueued: 'Synchronizacja kalendarza ruszyła — spotkania pojawią się za chwilę',
} as const;
